import { isCartServiceInitialPayment, isCartServiceMonthly, isCartServiceSeasonal, roundPrice } from "~/utils/payment";
import type CartPaymentInfo from "../../../cart/CartPaymentInfo";
import type DiscountInfo from "../../DiscountInfo";
import type CartDiscountStrategy from "./CartDiscountStrategy";
import type { DiscountInfoType } from "../../DiscountInfoType";

export default class CouponCartDiscountStrategy implements CartDiscountStrategy {
  getDiscountInfoType(): DiscountInfoType {
    return "coupon";
  }

  getDiscountInfo(cartPaymentInfo: CartPaymentInfo, currentSubtotal: number): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "coupon",
      description: "",
      value: 0,
      amount: 0,
    };

    /* Apply only the first coupon, if an order has more than one. */
    const coupon = cartPaymentInfo.coupons[0];
    if (coupon?.amount > 0) {
      /* Apply amount as dollar discount, only if matching seasonal service is found. */
      const isSeasonalServiceMatched = cartPaymentInfo.services.some(service => service.orderData?.id === coupon.orderItemId && isCartServiceSeasonal(service));
      if (isSeasonalServiceMatched) {
        discountInfo.description = `Coupon (${coupon.couponCode}) - ${coupon.description}`;
        discountInfo.value = coupon.amount;
        discountInfo.amount = roundPrice(coupon.amount, "nearest");
      }
    }

    return discountInfo;
  }

  getMonthlyDiscountInfo(cartPaymentInfo: CartPaymentInfo, currentSubtotal: number): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "coupon",
      description: "",
      value: 0,
      amount: 0,
    };

    /* Apply only the first coupon, if an order has more than one. */
    const coupon = cartPaymentInfo.coupons[0];
    if (coupon?.amount > 0) {
      /* Apply amount as dollar discount, only if matching monthly service is found. */
      const isMonthlyServiceMatched = cartPaymentInfo.services.some(service => service.orderData?.id === coupon.orderItemId && isCartServiceMonthly(service));
      if (isMonthlyServiceMatched) {
        discountInfo.description = `Coupon (${coupon.couponCode}) - ${coupon.description}`;
        discountInfo.value = coupon.amount;
        discountInfo.amount = roundPrice(coupon.amount, "nearest");
      }
    }

    return discountInfo;
  }

  getInitialPaymentDiscountInfo(cartPaymentInfo: CartPaymentInfo, currentSubtotal: number): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "coupon",
      description: "",
      value: 0,
      amount: 0,
    };

    /* Apply only the first coupon, if an order has more than one. */
    const coupon = cartPaymentInfo.coupons[0];
    if (coupon?.amount > 0) {
      /* Apply amount as dollar discount, only if matching initial payment service is found. */
      const isInitialPaymentServiceMatched = cartPaymentInfo.services.some(service => service.orderData?.id === coupon.orderItemId && isCartServiceInitialPayment(service));
      if (isInitialPaymentServiceMatched) {
        discountInfo.description = `Coupon (${coupon.couponCode}) - ${coupon.description}`;
        discountInfo.value = coupon.amount;
        discountInfo.amount = roundPrice(coupon.amount, "nearest");
      }
    }

    return discountInfo;
  }
}